(function (ws) {
    'use strict';
    ws.views.modalRequiredProduct = Backbone.View.extend({
        /**
         * Events
         */
        events: {
            'click .req-add-to-cart': 'addToCart',
            'click .remove-from-cart': 'removeFromCart',
            'click .child-product-row': 'removeErrorMessage',
            'click .child-row': 'selectRadioButton',
            'click [data-event="toggleConfirmationButtons"]': 'toggleConfirmationAndAddToCartButtons'
        },

        /**
         * Initialize function
         */
        initialize: function (options) {
            this.$apiError = $('.api-error-message');
            if (options) {
                this.template = _.template(options.template);
                this.data = options.data;
                this.model = options.model;
                this.isCart = options.isCart;
                this.render();
            }
        },

        /** z
         * Render function]
         */
        render: function () {
            this.$el.html(this.template(this.data));
            return this;
        },

        /**
         * Add to cart
         */
        addToCart: function () {
            $('.api-error-message').hide();
            const postRequest = {};
            const apiRequest = this.handlingProductContainer();
            postRequest.mainProductList = apiRequest;
            const mandatoryProducts = this.model;
            mandatoryProducts.set(postRequest);
            mandatoryProducts.set('quoteId', $('#quoteCode').val());
            mandatoryProducts.set('cart', this.isCart);

            this.$('.add-to-cart-mandatory').hide();
            if (this.mandatoryCrossSellCheck(apiRequest)) {
                this.$('.add-to-cart-mandatory').show();
            } else {
                this.$('.comp-tbl-simple').hide();
                this.$('.note-message').hide();
                this.$('.product-row-spinner').show();
                this.$('.req-add-to-cart').prop('disabled', true);
                this.$('.add-to-cart-mandatory').hide();
                mandatoryProducts.save().done(function (data) {
                    this.$('.success-add-message').show();
                    this.$('.success-add-message').find('.added-product').text(apiRequest[0].radioCheckedValue);
                    this.$('.product-row-spinner').hide();
                    this.$('.add-to-cart-btn').hide();
                    this.$('.req-add-to-cart').prop('disabled', false);
                    this.eventAgg.trigger('destroyView', this);
                    this.eventAgg.trigger('updateCart');
                    if ($('.cartPage').val() == 'true') {
                        if (data.onlySWPartNoError === true) {
                            this.eventAgg.trigger('openAddCartProductsModalWarning');
                        } else {
                            this.eventAgg.trigger($('.crt-add-prod-confirm').attr('id'));
                        }
                    } else {
                        if (data.onlySWPartNoError === true) {
                            this.eventAgg.trigger('openAddCartProductsModalWarning');
                        }
                    }
                }.bind(this)).fail(function() {
                    this.$('.comp-tbl-simple').show();
                    this.$('.note-message').show();
                    this.$('.product-row-spinner').hide();
                    this.$('.req-add-to-cart').prop('disabled', false);
                    $('.api-error-message').show();
                }.bind(this));
            }
        },

        removeFromCart () {
            const postRequest = {};
            const apiRequest = this.handlingProductContainer();
            apiRequest[0].associatedProductList = [];
            postRequest.mainProductList = apiRequest;
            const mandatoryProducts = this.model;
            mandatoryProducts.set(postRequest);
            mandatoryProducts.set('quoteId', $('#quoteCode').val());
            mandatoryProducts.set('cart', this.isCart);

            this.$('.comp-tbl-simple').hide();
            this.$('.note-message').hide();
            this.$('.product-row-spinner').show();
            this.$('.remove-from-cart').prop('disabled', true);
            this.$('.add-to-cart-mandatory').hide();
            mandatoryProducts.save().done(function () {
                this.$('.success-remove-message').show();
                this.$('.product-row-spinner').hide();
                this.$('.confirm-cancel-product').hide();
                this.$('.removeAfter').html('0');
                this.$('.product-quantity').addClass('red');
                this.$('.remove-from-cart').prop('disabled', false);
                this.eventAgg.trigger('destroyView', this);
                this.eventAgg.trigger('updateCart');
            }.bind(this)).fail(function() {
                this.$('.comp-tbl-simple').show();
                this.$('.note-message').show();
                this.$('.product-row-spinner').hide();
                this.$('.req-add-to-cart').prop('disabled', false);
                $('.api-error-message').show();
            }.bind(this));
        },

        /**
         *  Removing the error messages on select of the radio button
         */
        removeErrorMessage: function () {
            this.$('.add-to-cart-mandatory').hide();
        },

        /**
         *  selecting the nearest radio button on click of the row
         */
        selectRadioButton: function (e) {
            $(e.currentTarget).parent('tr').children('td:first-child').children('label.custom-radio-label').trigger('click');
        },

        /**
         * Creating API Request Params
         */
        handlingProductContainer: function () {
            var mainRequest = [];
            var $productContainer = this.$('.comp-quotedetail-required-product');
            _.each($productContainer, function (container) {
                var $productTable = $(container).find('.product-sections table tbody tr');
                var productArray = {};
                var associatedProducts = [];
                productArray.mainProductCode = $(container).find('.product-name').attr('prodName');
                productArray.mandatoryAttachment = $(container).data('mandatory');
                productArray.mainProductEntryNumber = $(container).find('.product-name').attr('entryNumber');
                productArray.radioChecked = $(container).find('.custom-radio').filter(':checked').length;
                _.each($productTable, function (product) {
                    var prod = {};
                    prod.code = $(product).find('td.part-no').text();
                    prod.partNumber = $(product).find('td.part-no').text();
                    if ($(product).find('.custom-radio').is(':checked')) {
                        productArray.radioCheckedValue = $(product).find('td.part-no').text();
                    }

                    prod.quantity = $(container).data('mandatory') ? ($(product).find('.custom-radio').is(':checked') ? $(product).find('.prod-qty input').val() : '')  : $(product).find('.prod-qty input').val();
                    associatedProducts.push(prod);
                });

                productArray.associatedProductList = associatedProducts;
                mainRequest.push(productArray);
            });

            return mainRequest;
        },

        /**
         * Allowing only one crossCell if Mandatory
         * @param {Object} apiRequest
         */
        mandatoryCrossSellCheck: function (apiRequest, close) {
            var quantityCount = 0;
            var mandatoryError = false;
            _.each(apiRequest, function (productInfo) {
                if (productInfo.mandatoryAttachment && !close) {
                    if (productInfo.radioChecked === 1) {
                        quantityCount = 0;
                    } else {
                        mandatoryError = true;
                    }
                } else if (close && productInfo.mandatoryAttachment) {
                    mandatoryError = true;
                }
            });
            return mandatoryError;
        },

        /**
         * Refresh cart table if user not adding associated products
         */
        toggleConfirmationAndAddToCartButtons: function() {
            $('.add-to-cart-mandatory').hide();
            this.showConfirmationButtons = !this.showConfirmationButtons;
            this.$('.confirm-cancel-product').toggle(this.showConfirmationButtons);
            this.$('.add-to-cart-btn').toggle(!this.showConfirmationButtons);
        }
    });
})(westcon);
